module.exports = __webpack_public_path__ + "static/media/close_black.776223ba.svg";